import styled from 'styled-components';

const ResourceSubMenuContainer = styled.div`
  @media (min-width: 1241px) {
    background: var(--white-color);
    border: 1px solid #e9eff2;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.08);
    box-sizing: border-box;
    position: absolute;
    padding: 0;
    transition: opacity 0.1s;
    z-index: 2147483647 !important;
    max-width: 1195px;
    width: auto;
    left: 10%;
    visibility: hidden;
    opacity: 0;
    margin-top: -20px;
    transition: all 0.25s ease-out;
    pointer-events: none;
    display: flex;
  }

  .resource-sub-menu--container {
    padding: 30px 40px;
    display: flex;
    width: 100%;

    .resource-sub-menu--left-side {
      flex: 4;
      padding-right: 25px;
      max-width: 450px;

      .resource-sub-menu--main-menu-item {
        .mega-menu-item--content {
          display: flex;
          align-items: center;

          .mega-menu-item--icon {
          }

          .mega-menu-item--title {
            font-weight: 900;
            font-size: 25px;
            line-height: 120%;
            letter-spacing: -0.02em;
            color: var(--normal-title-color);
            margin-bottom: 0;
            margin-left: 15px;

            &:hover {
              opacity: 0.8;
            }
          }
        }
      }

      .resource-sub-menu--subscribe-container {
        margin-top: 15px;

        .resource-sub-menu--subscribe-description {
          font-weight: 500;
          font-size: 20px;
          line-height: 150%;
          color: var(--normal-title-color);
        }

        .resource-sub-menu--subscribe-form {
          .signup-form--form {
            .data-layer-form {
              & > div {
                &:first-child {
                  width: 100%;

                  .text-field-wrapper .text-field-input {
                    margin-right: 0px;
                    width: calc(100% - 15px);
                  }
                }
              }
            }
          }
        }
      }
    }

    .resource-sub-menu--right-side {
      flex: 6;
      padding-left: 25px;
      max-width: ${props => (props.isNoDescription ? '465px' : '100%')};

      .resource-sub-menu--sub-title {
        font-weight: 900;
        font-size: 14px;
        line-height: 110%;
        letter-spacing: 0.05em;
        text-transform: uppercase;
        color: var(--normal-title-color);
        margin-bottom: 0;
        padding: 0 0 0 10px;
      }

      .resource-sub-menu--menu-content {
        list-style: none;
        margin: 0;
        padding: 25px 0 0;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;

        & > div {
          flex: 0 0 50%;
          padding: 0 !important;
          max-width: ${props => (props.isNoDescription ? '220px' : '100%')};

          &.mobile-view-only {
            display: none;

            @media (max-width: 1240px) {
              display: block;
            }
          }
        }

        .mega-menu-item {
          vertical-align: middle;
          margin-right: 5px;
          width: 100%;

          a {
            display: flex;
            align-items: center;
            padding: 10px;
            border-radius: 4px;
            justify-content: flex-start;

            &:hover {
              background: var(--blue-fourth);
            }

            .mega-menu-item--icon {
              border: none;
              width: 40px;
              height: 40px;

              img {
                width: 100%;
                height: 100%;
              }
            }

            .mega-menu-item--content {
              padding: 0 0 0 10px;
              align-self: center;

              .mega-menu-item--title {
                font-family: Sofia Pro;
                font-size: 17px;
                line-height: 17px;
                color: var(--normal-title-color);
                margin: 0;
                padding: 0;
              }

              .mega-menu-item--description {
                font-family: Sofia Pro;
                font-size: 13px;
                line-height: 150%;
                color: #71848c;
                margin: 5px 0 0;
              }
            }
          }
        }
      }
    }
  }

  @media (max-width: 1240px) {
    visibility: hidden;
    opacity: 0;
    transition: max-height 0.25s cubic-bezier(0.55, 0.085, 0.68, 0.53);
    margin-top: 0 !important;
    flex-direction: column;

    .resource-sub-menu--container {
      padding: 0;

      .resource-sub-menu--left-side {
        display: none;
      }

      .resource-sub-menu--right-side {
        padding-left: 0;
        max-width: 100%;

        .resource-sub-menu--sub-title {
          display: none;
        }

        .resource-sub-menu--menu-content {
          padding-top: 0;

          & > div {
            flex: 0 0 100%;
            width: 100%;
            max-width: 100%;
          }

          .mega-menu-item {
            a {
              padding: 0 28px 20px;

              &:hover {
                background: var(--white-color);

                .mega-menu-item--content {
                  .mega-menu-item--title {
                    color: var(--neutral-text-color);
                  }
                }
              }

              .mega-menu-item--content {
                .mega-menu-item--description {
                  display: none;
                }
              }
            }
          }
        }
      }
    }
  }
`;

export { ResourceSubMenuContainer };
